import React from 'react';
import { Grid } from '@mui/material';
import ArticlePreviewCard from '../containers/client/ArticlePreviewCard';
import { ArticleSummary } from '../../shared/types';
import {
    getArticleLink,
    getUserGuideArticleLink,
} from '../../utils/link.utils';
import { getPublishedData } from './PublishedBy';
import FetchMorePaginator from './FetchMorePaginator';
import { getLinkPrefix } from '../../utils/list-utils';

const DEFAULT_SCOPE_CHIP_LABEL = 'General';

interface ArticlePreviewListUIProps {
    source: string;
    showPagination?: boolean;
    articles: ArticleSummary[];
    hasNextPage: boolean;
    total?: number;
    fetchMore: () => void;
    displayShowMoreButton: boolean;
    displayArticleCount?: boolean;
    showScopeChipOnCards?: boolean;
    scopeLabelByScope?: Record<string, string>;
}

const ArticlePreviewListUI = ({
    articles,
    hasNextPage,
    source,
    showPagination = true,
    total,
    fetchMore,
    displayShowMoreButton,
    displayArticleCount = true,
    showScopeChipOnCards = false,
    scopeLabelByScope,
}: ArticlePreviewListUIProps) => {
    return (
        <Grid container spacing={2}>
            {articles.map((article: ArticleSummary) => {
                let scopeChipLabel: string | undefined;

                if (showScopeChipOnCards) {
                    const mappedScope = (article.userGuideScopes || []).find(
                        (scope) => !!scopeLabelByScope?.[scope]
                    );

                    scopeChipLabel = mappedScope
                        ? scopeLabelByScope?.[mappedScope]
                        : DEFAULT_SCOPE_CHIP_LABEL;
                }

                return (
                    <Grid
                        key={article._id}
                        size={{
                            xs: 12,
                            sm: 6,
                            md: 4,
                        }}
                    >
                        <ArticlePreviewCard
                            source={source}
                            title={article?.title}
                            channel={article?.premiumChannelDetails}
                            publishedData={getPublishedData(
                                article,
                                getLinkPrefix(),
                                true,
                                false
                            )}
                            articleLink={
                                source === 'userGuide'
                                    ? getUserGuideArticleLink(article._id)
                                    : getArticleLink(article._id)
                            }
                            scopeChipLabel={scopeChipLabel}
                            reserveScopeChipSpace={showScopeChipOnCards}
                        />
                    </Grid>
                );
            })}
            {showPagination && (
                <Grid
                    container
                    size={12}
                    sx={{
                        justifyContent: 'space-around',
                    }}
                >
                    <FetchMorePaginator
                        hasNextPage={hasNextPage}
                        label="articles"
                        showingCurrent={articles?.length}
                        totalCount={total || 0}
                        fetchMore={fetchMore}
                        displayShowMoreButton={displayShowMoreButton}
                        displayCount={displayArticleCount}
                    />
                </Grid>
            )}
        </Grid>
    );
};

export default ArticlePreviewListUI;
